import classNames from 'classnames';
import { FC, Fragment, ReactNode } from 'react';
import Radio from '.';
import styles from './Radio.module.scss';

interface RadioOption {
    label?: string | ReactNode;
    value?: string;
    disabled?: boolean;
}

interface RadioGroupProps {
    options?: RadioOption[];
    className?: string;
    name?: string;
    value?: string;
    defaultValue?: string;
    type?: 'default' | 'button';
    children?: ReactNode;
    id?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioGroup: FC<RadioGroupProps> = ({
    options,
    onChange,
    className,
    name,
    value,
    type = 'default',
    children,
    id
}) => {
    return (
        <Fragment>
            {id && <div id={id}></div>}
            {Array.isArray(options) && options.length && (
                <div className={classNames('flex flex-col gap-2', className)}>
                    {options.map((opt) => (
                        <Radio
                            {...opt}
                            type={type}
                            name={name}
                            id={opt.value}
                            key={opt.value}
                            checked={value ? opt.value === value : undefined}
                            onChange={onChange}
                        >
                            {opt.label}
                        </Radio>
                    ))}
                </div>
            )}
            {children}
        </Fragment>
    );
};

export default RadioGroup;
